import { useState } from "react";
import { Mail, Check, X } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function ChecklistSubscribe({ slug }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(false);

  if (dismissed) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await api.post("/newsletter/subscribe", { email, source: `checklist:${slug}` });
      setDone(true);
      toast.success(res.data.message || "You're subscribed!");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="checklist-subscribe-offer" className="mt-4 max-w-md rounded-2xl bg-white/90 backdrop-blur-sm border border-sand-200 p-5 shadow-[0_8px_32px_rgba(44,42,41,0.08)] animate-fade-up relative">
      <button
        data-testid="checklist-subscribe-dismiss"
        onClick={() => setDismissed(true)}
        aria-label="No thanks"
        className="absolute top-3 right-3 text-charcoal-400 hover:text-charcoal-700"
      >
        <X size={16} />
      </button>
      {done ? (
        <div className="flex items-center gap-3" data-testid="checklist-subscribe-success">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-sage text-white"><Check size={18} /></span>
          <p className="text-sm text-charcoal-700">You're on the list — enjoy the checklist!</p>
        </div>
      ) : (
        <>
          <div className="flex items-center gap-2 text-charcoal-800">
            <Mail size={16} className="text-terracotta" />
            <p className="text-sm font-medium">Your download has started. Want more tips like this?</p>
          </div>
          <p className="text-xs text-charcoal-500 mt-1">Totally optional — occasional move-to-Mexico advice, no spam.</p>
          <form onSubmit={submit} className="mt-3 flex gap-2">
            <input
              type="email"
              required
              data-testid="checklist-subscribe-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="flex-1 rounded-full border border-sand-200 px-4 py-2 text-sm text-charcoal-800 focus:outline-none focus:ring-2 focus:ring-sage/50"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="checklist-subscribe-submit"
              className="rounded-full bg-terracotta px-5 py-2 text-sm font-medium text-white hover:bg-terracotta-hover transition-colors disabled:opacity-60 whitespace-nowrap"
            >
              {loading ? "…" : "Subscribe"}
            </button>
          </form>
        </>
      )}
    </div>
  );
}
